// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__QYrn9","errors":"Errors_errors__1QQLO"};